import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import SVG from "react-inlinesvg";
import classNames from "classnames";
import config from "../../../config.json";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { LanguagePicker, } from "../../components/Shared/Controls";
import logo from "../../resources/images/logo.svg";
import AppStore from "../../resources/images/appStore.png";
import PhoneMockup from "../../resources/images/phone_mockup.png";
import GooglePlay from "../../resources/images/googlePlay.png";
import TermsOfUse from "../../components/Shared/PopUps/TermsOfUse";
import PrivacyPolicy from "../../components/Shared/PopUps/PrivacyPolicy";
import AlreadyCompletedSignup from "../../components/Shared/PopUps/AlreadyCompletedSignup";
import Accessibility from "../../components/Shared/PopUps/Accessibility";
import s from "./style.scss";
import Banner from "../components/Banner";
import { checkInviteCodeAsyncAction } from "../../store/Invite/Sagas";
const InviteRedirect = ({ hasInviteCode, requestCheckInviteCodeStatus, requestCheckInviteCodeError }) => {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const url = query.get('url');
    const name = query.get('name');
    const phone = query.get('ph');
    const email = query.get("email");
    const [appUrl, setAppUrl] = useState("");
    const [webUrl, setWebUrl] = useState("");
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const buildCompleteUrl = (url, name, email, phone) => {
        if (!url)
            return null;
        try {
            let urlParts = url.split("?");
            let appPath = urlParts[0];
            let search = urlParts[1];
            let appPathParts = appPath.split("://");
            let scheme = appPathParts[0];
            let path = appPathParts[1];
            let builtUrl = `${path}?${search}`;
            if (!!name) {
                builtUrl += `&name=${name}`;
            }
            if (!!email) {
                builtUrl += `&email=${email}`;
            }
            if (!!phone) {
                builtUrl += `&ph=${phone}`;
            }
            return {
                scheme,
                path,
                builtUrl,
                fullUrl: `${scheme}://${builtUrl}`
            };
        }
        catch (e) {
            console.log(e);
            return null;
        }
    };
    useEffect(() => {
        if (requestCheckInviteCodeStatus === "success" && hasInviteCode === false) {
            // User's account was found but doesn't have an invite code - they've already completed signup
            setShowAlreadyCompletedPopup(true);
        }
        else if (requestCheckInviteCodeStatus === "success" && hasInviteCode === true) {
            // User has an invite code, redirect to app
            const urlData = buildCompleteUrl(url, name, email, phone);
            if (urlData) {
                window.location.href = urlData.fullUrl;
            }
        }
        else {
            setShowAlreadyCompletedPopup(false);
        }
    }, [hasInviteCode, requestCheckInviteCodeStatus, url, name, email, phone]);
    useEffect(() => {
        for (let [key, value] of query) {
            console.log(`${key}=${value}`);
        }
        const urlData = buildCompleteUrl(url, name, email, phone);
        if (urlData) {
            let pathSegments = urlData.path.split("/");
            let accountId = pathSegments[1];
            if (accountId) {
                dispatch(checkInviteCodeAsyncAction(accountId));
            }
            else {
                navigate("/signin");
            }
            console.log(`${urlData.fullUrl}`);
            console.log(`https://${window.location.hostname}/${urlData.builtUrl}`);
            setAppUrl(urlData.fullUrl);
            if (window.location.hostname == "localhost")
                setWebUrl(`http://localhost:8080/${urlData.builtUrl}`);
            else
                setWebUrl(`https://${window.location.hostname}/${urlData.builtUrl}`);
        }
    }, [url, name, email, phone, dispatch, navigate]);
    const { t } = useTranslation();
    const [selectedLang, setLanguage] = useState(localStorage.getItem("i18nextLng") || "en");
    const [termsOfUseIsOpen, setTermsOfUseIsOpen] = useState(false);
    const [accessibilityIsOpen, setAccessibilityIsOpen] = useState(false);
    const [isOpenPrivacyPolicy, setPrivacyPolicyOpen] = useState(false);
    const [showAlreadyCompletedPopup, setShowAlreadyCompletedPopup] = useState(false);
    return (React.createElement("div", null,
        React.createElement(TermsOfUse, { isOpen: termsOfUseIsOpen, setIsOpen: setTermsOfUseIsOpen }),
        React.createElement(Accessibility, { isOpen: accessibilityIsOpen, setIsOpen: setAccessibilityIsOpen }),
        React.createElement(PrivacyPolicy, { isOpen: isOpenPrivacyPolicy, setIsOpen: setPrivacyPolicyOpen }),
        React.createElement(AlreadyCompletedSignup, { isOpen: showAlreadyCompletedPopup, setIsOpen: setShowAlreadyCompletedPopup }),
        React.createElement(Banner, null),
        React.createElement("div", { className: s.splash },
            React.createElement("div", { className: s.header },
                React.createElement(SVG, { src: logo, className: s.logoIcon }),
                React.createElement(LanguagePicker, { style: s.languagePicker, selected: selectedLang, setLanguage: setLanguage })),
            React.createElement("div", { className: s.splashContent },
                React.createElement("div", { className: s.splashSubContent },
                    React.createElement("div", { className: s.helpBlockFirst },
                        React.createElement("p", { className: s.getApp }, t("redirectingToApp ")),
                        React.createElement("p", { className: s.helpText }, t("notOpening")),
                        React.createElement("a", { className: classNames(s.button, s.primary), href: appUrl }, t("openInApp")),
                        React.createElement("a", { className: classNames(s.button, s.primary), href: webUrl }, t("continueOnWeb")))),
                React.createElement("div", { className: s.splashSubContentSecond },
                    React.createElement("img", { className: s.devices, src: PhoneMockup }),
                    React.createElement("div", { className: s.info },
                        React.createElement("div", { className: s.getApp }, "Get Amgen Entrust\u00AE Patient App for your devices"),
                        React.createElement("div", { className: classNames(s.badges, s.inline, s.fs18) },
                            React.createElement("a", { target: "_blank", href: config.appstore_download_link },
                                React.createElement("img", { src: AppStore, className: s.badge })),
                            React.createElement("a", { target: "_blank", href: config.play_market_download_link },
                                React.createElement("img", { src: GooglePlay, className: s.badge })))))),
            React.createElement("div", { className: s.splashFooter },
                React.createElement("div", { className: s.paragraph_1 }),
                React.createElement("div", { className: s.splashFooter__links },
                    React.createElement("a", { className: s.paragraph_1, onClick: () => setTermsOfUseIsOpen(true) }, t("termOfUse")),
                    React.createElement("a", { target: "_blank", className: s.paragraph_1, onClick: () => setPrivacyPolicyOpen(true) }, t("privacyPolicy")),
                    React.createElement("a", { className: s.paragraph_1, onClick: () => setAccessibilityIsOpen(true) }, t("accessibility")))))));
};
const mapStateToProps = (state) => ({
    hasInviteCode: state.invite.hasInviteCode,
    requestCheckInviteCodeStatus: state.invite.requestCheckInviteCodeStatus,
    requestCheckInviteCodeError: state.invite.requestCheckInviteCodeError
});
export default connect(mapStateToProps)(InviteRedirect);
